// Copyright (c) Bentley Systems

export type OnPremUsageRecord = {
  systemId: string;
  projectId: string;
  projectName: string;
  timesUsed: number;
  lastTimeUsed: string;
};

export type MqttClientOverview = {
  mqttClientName: string;
  isUpgraded: boolean;
  upgradedAt?: string;
  upgradedByName?: string;
  usages: OnPremUsageRecord[];
};

export type ITwinRoutingOverview = {
  iTwinId: string;
  displayName?: string;
  mqttClients: MqttClientOverview[];
};

export type OnPremRoutingOverviewResponse = {
  iTwins: ITwinRoutingOverview[];
};

/** Computed routing status for an iTwin: Legacy if any MQTT client is not upgraded, Isolated otherwise. */
export type RoutingStatus = "Legacy" | "Isolated";

export function computeITwinStatus(iTwin: ITwinRoutingOverview): RoutingStatus {
  if (iTwin.mqttClients.length === 0) {
    return "Isolated";
  }
  return iTwin.mqttClients.some((c) => !c.isUpgraded) ? "Legacy" : "Isolated";
}
